/* Safe wrappers for localStorage and a small one-shot migration
     to keep backward-compatibility with prior keys (like "token"). */

import { LEGACY_KEYS, STORAGE_USER } from './storageKeys';

//==============================================================================
// Safe localStorage read (handles SSR or browser quirks) 
//==============================================================================
export function lsGet(key) {
  try { return localStorage.getItem(key); } catch { return null; }
}

//==============================================================================
// Safe localStorage write 
//==============================================================================
export function lsSet(key, value) {
  try { localStorage.setItem(key, value); } catch { /* no-op */ }
}

//==============================================================================
/// Safe localStorage remove
//==============================================================================
export function lsRemove(key) {
  try { localStorage.removeItem(key); } catch { /* no-op */ }
}

//==============================================================================
/**
 * One-time migration:
 * - If legacy "token" exists and new user token is empty, move it.
 * This preserves existing sessions without forcing a re-login.
 */
//==============================================================================
export function runStorageMigrationOnce() {
  try {
    const MIGRATION_FLAG = 'app.migrations.v1.storageKeys';
    if (lsGet(MIGRATION_FLAG)) return; // already migrated

    const legacyToken = lsGet(LEGACY_KEYS.token);
    const newUserToken = lsGet(STORAGE_USER.token);

    if (legacyToken && !newUserToken) {
      lsSet(STORAGE_USER.token, legacyToken);
      // Keep the legacy token for a while (do NOT remove now to avoid surprises).
      // You may remove it in a later release if desired:
      // lsRemove(LEGACY_KEYS.token);
    }

    lsSet(MIGRATION_FLAG, 'true');
  } catch {
    // swallow errors: migration is best-effort
  }
}
